import getSyncToExagonInventory from '@hooks/configuration/getSyncToExagonInventory';

const useGetSyncToExagonInventory = (id) => getSyncToExagonInventory(id);

export default useGetSyncToExagonInventory;
